import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Router } from '@angular/router';
import { PoNotificationService } from '@po-ui/ng-components';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { InstanciasService } from 'src/app/app.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private instService: InstanciasService,
        private poNotification: PoNotificationService) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if ((error.status === 401 || error.status === 403) && !req.url.includes('login.php')) {
                    this.instService.removesessionStorage();

                    if (this.router.url !== '/login') {
                        this.poNotification.warning('Sua sessão expirou. Faça login novamente.');
                        this.router.navigate(['/login']);
                    }
                }

                return throwError(() => error);
            })
        );
    }
}
